import { motion } from "framer-motion";
import { size } from "polished";
import styled, { css } from "styled-components";

import * as helpers from "../../../styles/helpers";
import layers from "../../../styles/layers";

import { IModalBaseProps } from "./interfaces";

export const Overlay = styled.div`
  ${helpers.overlayBackdrop}
`;

export const Dialog = styled.div`
  ${size("100%")}

  position: relative;

  overflow-y: auto;

  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

export const Container = styled(motion.div)<IModalBaseProps>`
  ${size("100%")}

  position: fixed;
  top: 0;
  left: 0;
  z-index: ${layers.modals};

  ${(props) =>
    props.centered &&
    css`
      ${Dialog} {
        align-items: center;
      }
    `}

  ${(props) =>
    props.bottom &&
    css`
      ${Dialog} {
        align-items: flex-end;
      }
    `}
`;
